<template>
    <div>
        <h2>Abstract</h2>
        <p>{{ abstractText }}</p>
    </div>
</template>

<script>
import text from "../assets/data/abstract_text.json";

export default {
    name: "ArticleAbstract",
    data() {
        return {
            abstractText: text,
        }
    },
}
</script>